import {useIntl} from 'react-intl';
import type {Citation} from '../../../../store/features/calls/callsService';
import {formatTime} from '../../../../utilis/timeUtilis';
import {insightsMessages as m} from '../insightsMessages';
import {timeChip} from '../insightsUi';
import {useInsightsActions} from '../InsightsActions';

export const CitationChip = ({citation}: {citation: Citation}) => {
    const intl = useIntl();
    const {jumpToCitation} = useInsightsActions();
    const time = formatTime(citation.startTime);
    return (
        <button
            type="button"
            onClick={() => jumpToCitation(citation)}
            aria-label={intl.formatMessage(m.citation, {time})}
            className={timeChip}
        >
            {time}
        </button>
    );
};

export const Citations = ({citations}: {citations?: Citation[] | null}) => {
    if (!citations?.length) return null;
    return (
        <span className="ml-1.5 inline-flex flex-wrap gap-1 align-middle">
            {citations.map((citation) => <CitationChip key={citation.segmentId} citation={citation}/>)}
        </span>
    );
};
